/// <amd-module name="Wit/WorkItemModel/RuleEngine/WorkItemIdentityScope" />
import { localeIgnoreCaseComparer } from "VSS/Core/Util/String";
import { IWorkItemIdentityScope } from "Wit/WorkItemModel/OM/WorkItemInterfaces";
import { FilterByScope } from "./FilterByScope";

export class WorkItemIdentityScope extends FilterByScope implements IWorkItemIdentityScope {
    public static equals(filterByScope1: WorkItemIdentityScope, filterByScope2: WorkItemIdentityScope): boolean {
        if (filterByScope1 == null && filterByScope2 == null) {
            return true;
        }
        if (FilterByScope.GetHashCode(filterByScope1) !== FilterByScope.GetHashCode(filterByScope2)) {
            return false;
        }
        // FilterByScope GetHashCode only counts ancestorEntityIds and EntityIds
        // we cannot determine even if FilterByScope GetHashCode are the same
        const filterByScope1NonIdLength = filterByScope1.nonIdentities == null ? 0 : filterByScope1.nonIdentities.length;
        const filterByScope2NonIdLength = filterByScope2.nonIdentities == null ? 0 : filterByScope2.nonIdentities.length;
        if (filterByScope1NonIdLength != filterByScope2NonIdLength) {
            return false;
        }

        const filterByScope1NonIdentitiesStr = filterByScope1.nonIdentities == null ? "" : filterByScope1.nonIdentities.sort().join(",");
        const filterByScope2NonIdentitiesStr = filterByScope2.nonIdentities == null ? "" : filterByScope2.nonIdentities.sort().join(",");

        return localeIgnoreCaseComparer(filterByScope1NonIdentitiesStr, filterByScope2NonIdentitiesStr) === 0;
    }

    public nonIdentities: string[];
    public displayNames: string[];
    public excludeGroups: boolean;

    constructor(
        filterByAncestorEntityIds?: string[],
        filterByEntityIds?: string[],
        nonIdentities?: string[],
        displayNames?: string[],
        excludeGroups?: boolean
    ) {
        super(filterByAncestorEntityIds, filterByEntityIds);
        this.nonIdentities = nonIdentities || [];
        this.displayNames = displayNames || [];
        this.excludeGroups = excludeGroups || false;
    }
}
